const ExtraInfo = () => {
    return (
        <div className="extraInfo">
            <div>
                <h2>Blockbusters Reborn</h2>
                <a href="#FAQ">FAQ</a>
                <a href="#Media Centre">Media Centre</a>
                <a href="#Blockbusters Shop">Blockbuster Shop</a>
                <a href="#Ways to Watch">Ways To Watch</a>
                <a href="#Speed Test">Speed Test</a>
                <a href="#Only on BlockBusters">Only on BlockBusters</a>
            </div>

            <div>
                <h2>Legal Info</h2>
                <a href="#Help Centre">Help Centre</a>
                <a href="#Investor Relations">Investor Relations</a>
                <a href="#Redeem gift cards">Redeem gift cards</a>
                <a href="#Terms of Use">Terms of Use</a>
                <a href="#Corporate Information">Corporate Information</a>
                <a href="#Legal Guarantee">Legal Guarantee</a>
                <a href="#Legal Notices">Legal Notices</a>
            </div>

            <div>
                <h2>Other Info</h2>
                <a href="#Shipping">Shipping</a>
                <a href="#Contact Us">Contact us</a>
                <a href="#Returns">Returns</a>
                <a href="#Rewards">Rewards</a>
                <a href="#Terms & Conditions">Terms & Conditions</a>
            </div>

            <div>
                <h2>Help</h2>
                <a href="#Account">Track Packages</a>
                <a href="#Jobs">Jobs</a>
                <a href="#Buy Gift Cards">Buy Gift Cards</a>
                <a href="#Contact Us">Contact Us</a>
                <a href="#Customer Services">Customer Services</a>
            </div>
        </div>
    )
}

export default ExtraInfo;